import apiClient from './client'
import { LoginRequest, LoginResponse, User, AuthTokens } from '@/types/auth'

export const authAPI = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    console.log('authAPI - Login request:', credentials.username)

    const formData = new FormData()
    formData.append('username', credentials.username)
    formData.append('password', credentials.password)

    const response = await apiClient.post<any>('/auth/login', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    console.log('authAPI - Login response:', response.data)

    // Save tokens
    const { access_token, refresh_token } = response.data
    localStorage.setItem('auth_tokens', JSON.stringify({ access_token, refresh_token }))

    // Now fetch the current user data using the new token
    apiClient.setAuthTokens({ access_token, refresh_token })

    try {
      const userResponse = await apiClient.get<User>('/users/me')
      console.log('authAPI - User data fetched:', userResponse.data)

      const user = userResponse.data
      localStorage.setItem('user', JSON.stringify(user))

      console.log('authAPI - Saved to localStorage, user:', user)

      return {
        access_token,
        refresh_token,
        token_type: 'bearer',
        user,
      }
    } catch (error) {
      console.error('authAPI - Failed to fetch user data:', error)
      // Clear tokens if we can't get user data
      localStorage.removeItem('auth_tokens')
      throw error
    }
  },

  logout: async (): Promise<void> => {
    try {
      await apiClient.post('/auth/logout')
    } finally {
      localStorage.removeItem('auth_tokens')
      localStorage.removeItem('user')
    }
  },

  getCurrentUser: (): User | null => {
    try {
      const userStr = localStorage.getItem('user')
      if (!userStr || userStr === 'undefined') {
        return null
      }
      return JSON.parse(userStr)
    } catch (error) {
      console.error('Failed to parse user data:', error)
      return null
    }
  },

  isAuthenticated: (): boolean => {
    try {
      const tokens = localStorage.getItem('auth_tokens')
      return !!tokens && tokens !== 'undefined'
    } catch {
      return false
    }
  },

  getAuthTokens: (): AuthTokens | null => {
    try {
      const tokens = localStorage.getItem('auth_tokens')
      if (tokens && tokens !== 'undefined') {
        return JSON.parse(tokens) as AuthTokens
      }
      return null
    } catch (error) {
      console.error('Failed to parse auth tokens:', error)
      return null
    }
  },
}